import { render, staticRenderFns } from "./LostMyPass.vue?vue&type=template&id=e5472a4e&scoped=true"
import script from "./LostMyPass.vue?vue&type=script&lang=js"
export * from "./LostMyPass.vue?vue&type=script&lang=js"
import style0 from "./LostMyPass.vue?vue&type=style&index=0&id=e5472a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5472a4e",
  null
  
)

export default component.exports